var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 95,
    rx: 12,
    fill: "url(#paint0_radial_3370_7745)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9583 63.0834H39.6117C37.358 63.0834 35.5654 61.9867 33.956 60.4534C30.6611 57.3144 36.0707 54.8059 38.1339 53.5774C40.9821 51.8815 44.281 51.184 47.5 51.4847",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6042 40.4792C52.6042 44.1036 49.6661 47.0417 46.0417 47.0417C42.4173 47.0417 39.4792 44.1036 39.4792 40.4792C39.4792 36.8549 42.4173 33.9167 46.0417 33.9167C49.6661 33.9167 52.6042 36.8549 52.6042 40.4792Z",
    stroke: "white",
    strokeWidth: 2.1875
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.75 60.7501L62.0833 63.0834M60.9167 56.6667C60.9167 53.7673 58.5661 51.4167 55.6667 51.4167C52.7672 51.4167 50.4167 53.7673 50.4167 56.6667C50.4167 59.5662 52.7672 61.9167 55.6667 61.9167C58.5661 61.9167 60.9167 59.5662 60.9167 56.6667Z",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3370_7745",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.1733 65.9267) rotate(-90) scale(65.9267 99.4785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D9D67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217494,
    stopColor: "#1E8157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510916,
    stopColor: "#1F6546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726911,
    stopColor: "#1F573E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204533"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.3e55073886e4e8bda57f98b90bad0781.svg";
export { ForwardRef as ReactComponent };